import { render, staticRenderFns } from "./ShiftWorkConfig.vue?vue&type=template&id=3aafb258&scoped=true"
import script from "./ShiftWorkConfig.vue?vue&type=script&lang=js"
export * from "./ShiftWorkConfig.vue?vue&type=script&lang=js"
import style0 from "./ShiftWorkConfig.vue?vue&type=style&index=0&id=3aafb258&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aafb258",
  null
  
)

export default component.exports